import { Loading } from "@alpaca/framework";
import "./LoadingScreen.css";

const LoadingScreen = () => {
  return (
    <div className="loading__container animate__animated animate__fadeIn">
      <Loading />
    </div>
  );
};

export default LoadingScreen;
